import { MimeType } from 'vet-bones/constants';

import { ProjectPropertyType } from 'src/constants/project';
import { ModelSnapshot } from 'src/containers/ProjectDiagram/types/model';
import { newline } from 'src/templates/copy';
import { ExportToFileOptions } from 'src/utils/exportToFile';
import { stringifyModelConceptAttributes } from 'src/utils/stringify/modelConceptAttributes';
import { stringifyModelConceptClasses } from 'src/utils/stringify/modelConceptClasses';
import { stringifyModelConceptRelationships } from 'src/utils/stringify/modelConceptRelationships';
import { stringToFilename } from 'src/utils/stringToFilename';

export const exportModel = ({
  fileNamePrefix = '',
  name,
  model,
  projectModelIds,
  projectPropertyType,
  targetModelId,
}: {
  fileNamePrefix?: string;
  name: string;
  model: ModelSnapshot;
  projectModelIds?: Set<string>;
  projectPropertyType: ProjectPropertyType;
  targetModelId: string;
}): ExportToFileOptions => {
  const filename = `${fileNamePrefix}${stringToFilename(name)}.ttl`;
  const classes = stringifyModelConceptClasses({
    model,
    projectModelIds,
    targetModelId,
  });
  const relationships = stringifyModelConceptRelationships({
    model,
    projectPropertyType,
    projectModelIds,
    targetModelId,
  });
  const attributes = stringifyModelConceptAttributes({
    model,
    projectPropertyType,
    projectModelIds,
    targetModelId,
  });
  const contents =
    [classes, relationships, attributes].filter((str) => str).join('\n\n') +
    newline;

  return { contents, filename, mimeType: MimeType.TURTLE };
};
